//IMPORTING COLORS
import { WHITE, TEXT_COLOR } from "../../utils/colors";

//IMPORTING FONT
import { SUB_TEXT_SIZE } from "../../utils/fonts";

import LoadingContainer from "../LoadingContainer";
import ErrorContainer from "../ErrorContainer";
import { clientCMSvelas } from "../../sanity/clientCMSvelas";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { LuCircleCheckBig } from "react-icons/lu";
import { MdOutlinePortableWifiOff } from "react-icons/md";
import CandleOff from "../../assets/images/candle-off.webp";
import Candle2 from "../../assets/video/candle-light-2.webm";
import "./CandleModal.css";
import { Link } from "react-router-dom";

function CandleModal(props) {
  const [candlesMessagesData, setCandlesMessagesData] = useState(null);
  const [dataContainer, setDataContainer] = useState(null);
  const [messageContainer, setMessageContainer] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const candleSchema = Yup.object().shape({
    forPerson: Yup.string()
      .min(3, "Preencha o nome do falecido(a)")
      .max(50, "Nome muito extenso")
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚãõÃÕäëïöüÄËÏÖÜçÇâêîôûÂÊÎÔÛ ]*$/,
        "Insira somente letras"
      )
      .required("Nome obrigatório"),
    byPerson: Yup.string()
      .min(3, "Preencha o seu nome")
      .max(50, "Nome muito extenso")
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚãõÃÕäëïöüÄËÏÖÜçÇâêîôûÂÊÎÔÛ ]*$/,
        "Insira somente letras"
      )
      .required("Nome obrigatório"),
    message: Yup.string().required("Mensagem obrigatória"),
    terms: Yup.boolean().oneOf([true], "Termo obrigatório"),
  });

  useEffect(() => {
    setDataContainer(LoadingContainer);
    clientCMSvelas
      .fetch(
        `*[_type == "message"] {
          _id,
          description
      }`
      )
      .then((data) => {
        setCandlesMessagesData(data);
      })
      .catch((error) => {
        console.error("An error occurred:", error.message);
        if (!candlesMessagesData) setDataContainer(ErrorContainer);
        else setDataContainer(LoadingContainer);
      });
  }, []);

  const sucessFormState = (
    <div style={{ backgroundColor: WHITE }} className="candle-modal-msg">
      <div className="candle-modal-msg-content">
        <video
          className="candle-modal-msg-img"
          autoPlay
          loop
          muted
          preload="metadata"
          playsInline
        >
          <source src={Candle2} type="video/webm" />
        </video>
        <div className="candle-modal-text">
          <h4 className="candle-modal-title-sucess">
            <LuCircleCheckBig className="candle-modal-icon-sucess" />
            Vela acesa com sucesso, obrigado!
          </h4>
          <button
            type="button"
            onClick={props.onHide}
            style={{
              color: WHITE,
              backgroundColor: props.btncolor,
              fontSize: SUB_TEXT_SIZE,
            }}
            className="primary-btn-modal"
          >
            <a href="/velas-virtuais/"> VER VELAS</a>
          </button>
        </div>
      </div>
    </div>
  );

  const failureFormState = (
    <div style={{ backgroundColor: WHITE }} className="candle-modal-msg">
      <div className="candle-modal-msg-content">
        <img src={CandleOff} alt="vela" className="candle-modal-img" />
        <div className="candle-modal-text">
          <h4 className="candle-modal-title-failure">
            <MdOutlinePortableWifiOff className="candle-modal-icon-failure" />
            Não foi possível acender a vela, tente mais tarde.
          </h4>
          <button
            type="button"
            onClick={props.onHide}
            style={{
              color: TEXT_COLOR,
              backgroundColor: WHITE,
              fontSize: SUB_TEXT_SIZE,
            }}
            className="simple-btn-modal"
          >
            VOLTAR
          </button>
        </div>
      </div>
    </div>
  );

  async function handleSubmit(values) {
    try {
      setLoading(true);
      const newDoc = await clientCMSvelas.create({
        _type: "candle",
        title: values.title,
        byPerson: values.byPerson,
        forPerson: values.forPerson,
        message: { _type: "reference", _ref: values.message },
        publishedAt: values.publishedAt,
        terms: values.terms,
      });
      console.log("Candle created:", newDoc);
      setMessageContainer(sucessFormState);
    } catch (error) {
      console.error("Error creating document:", error);
      setMessageContainer(failureFormState);
    }
  }

  return (
    <Modal {...props}>
      <Modal.Body>
        {!messageContainer ? (
          <div className="candle-modal">
            <img src={CandleOff} alt="vela" className="candle-modal-img" />
            <Formik
              initialValues={{
                title: "Mensagem Online",
                byPerson: "",
                forPerson: props.falecido,
                message: "",
                publishedAt: "",
                terms: true,
              }}
              validationSchema={candleSchema}
              onSubmit={(values) => {
                const actualDate = new Date();
                values.publishedAt = actualDate.toISOString();
                handleSubmit(values);
              }}
            >
              {({ errors, touched }) => (
                <Form className="candle-modal-form">
                  <label
                    className="candle-label-modal"
                    style={{ color: TEXT_COLOR }}
                  >
                    Em memória de
                  </label>
                  <Field
                    name="forPerson"
                    type="text"
                    placeholder="Nome do falecido(a)"
                    className="candle-modal-form-input"
                  />
                  {errors.forPerson && touched.forPerson ? (
                    <div className="candle-modal-error">{errors.forPerson}</div>
                  ) : null}
                  <label
                    className="candle-label-modal"
                    style={{ color: TEXT_COLOR }}
                  >
                    Mensagem de
                  </label>
                  <Field
                    name="byPerson"
                    type="text"
                    placeholder="Seu nome"
                    className="candle-modal-form-input"
                  />
                  {errors.byPerson && touched.byPerson ? (
                    <div className="candle-modal-error">{errors.byPerson}</div>
                  ) : null}
                  <label
                    className="candle-label-modal"
                    style={{ color: TEXT_COLOR }}
                  >
                    Escolha uma mensagem
                  </label>
                  <div className="candle-modal-form-container">
                    <div id="my-radio-group">
                      <div role="group" aria-labelledby="my-radio-group">
                        {candlesMessagesData && candlesMessagesData.length > 0
                          ? candlesMessagesData &&
                            candlesMessagesData.map((candle, index) => (
                              <label
                                key={index}
                                className="candle-modal-form-message"
                                style={{ color: TEXT_COLOR }}
                              >
                                <Field
                                  type="radio"
                                  name="message"
                                  value={candle._id}
                                  style={{
                                    backgroundColor: props.btncolor,
                                    accentColor: props.btncolor,
                                  }}
                                />
                                {candle.description}
                              </label>
                            ))
                          : dataContainer}
                      </div>
                    </div>
                  </div>
                  {errors.message ? (
                    <div className="candle-modal-error">{errors.message}</div>
                  ) : null}
                  <label
                    className="candle-label-modal-privacy"
                    style={{ color: TEXT_COLOR }}
                  >
                    <Field
                      type="checkbox"
                      name="terms"
                      style={{
                        backgroundColor: props.btncolor,
                        accentColor: props.btncolor,
                      }}
                    />
                    Li e concordo com a{" "}
                    <Link
                      style={{ color: TEXT_COLOR }}
                      to="/privacidade/"
                      rel="noopener noreferrer"
                      className="privacy-modal-link"
                      target="_blank"
                    >
                      {" "}
                      Política de Privacidade e de Cookies.
                    </Link>
                  </label>
                  {errors.terms ? (
                    <div className="candle-modal-error">{errors.terms}</div>
                  ) : null}
                  <div className="candle-modal-footer">
                    <button
                      type="submit"
                      style={{
                        color: WHITE,
                        backgroundColor: props.btncolor,
                        fontSize: SUB_TEXT_SIZE,
                      }}
                      className="primary-btn-modal"
                      disabled={isLoading}
                    >
                      {isLoading ? "Aguarde..." : " ACENDER VELA"}
                    </button>
                    <button
                      type="reset"
                      onClick={props.onHide}
                      className="simple-btn-modal"
                      style={{
                        color: TEXT_COLOR,
                        fontSize: SUB_TEXT_SIZE,
                      }}
                    >
                      CANCELAR
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        ) : (
          messageContainer
        )}
      </Modal.Body>
    </Modal>
  );
}

export default CandleModal;
